const SITE_TITLE = 'OpenNeuro Repository';
const SITE_SLOGAN = 'Welcome';
// Replaces the Universal Analytics property (UA-122146455-1), shut down in 2023.
const GOOGLE_ANALYTICS_TRACKING_ID = 'G-4Y9DZ3VCKD';
const XOONIPS_ITEMTYPES = ['binder', 'paper', 'data', 'tool', 'presentation', 'model'];
// The site information pages are a pico module named "credits".
const PICO_MODULES = ['credits'];

// Vite's BASE_URL always carries a trailing slash ('/' when the app is served
// from the document root). Strip it so it can be concatenated the same way
// CRA's Config.BASE_URL was.
const BASE_URL = import.meta.env.BASE_URL.replace(/\/$/, '');

export type MultiLang = 'en' | 'ja';

const Config = {
    SITE_TITLE,
    SITE_SLOGAN,
    GOOGLE_ANALYTICS_TRACKING_ID,
    XOONIPS_ITEMTYPES,
    PICO_MODULES,
    BASE_URL,
};

export default Config;
